export default __webpack_public_path__ + "static/media/jsx.249b64fe.md";